import { graphql } from '@/gql';
import type { GetGroceryCostQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getGroceryCost = async ({
  phoneNumber,
  serviceFee,
  numberOfItems,
  noGoGoFee,
  doNotCharge,
  applyDiscountedFee,
}: GetGroceryCostQueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      phoneNumber,
      serviceFee,
      numberOfItems,
      noGoGoFee,
      doNotCharge,
      applyDiscountedFee,
    },
    query: graphql(`
      query GetGroceryCost(
        $phoneNumber: String!
        $serviceFee: Float!
        $numberOfItems: Float!
        $noGoGoFee: Boolean
        $doNotCharge: Boolean
        $applyDiscountedFee: Boolean
      ) {
        getGroceryCost(
          phoneNumber: $phoneNumber
          serviceFee: $serviceFee
          numberOfItems: $numberOfItems
          noGoGoFee: $noGoGoFee
          doNotCharge: $doNotCharge
          applyDiscountedFee: $applyDiscountedFee
        ) {
          serviceFee
          gogoFee
          total
        }
      }
    `),
  });

  return response.data.getGroceryCost;
};
